// Runtime configuration loaded from /config.json (deployed by CDK)
// Falls back to VITE_* env vars for local development

export interface AppConfig {
  apiUrl: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
}

let cachedConfig: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cachedConfig) {
    return cachedConfig;
  }

  // Try to load runtime config from /config.json (deployed by CDK)
  try {
    const response = await fetch('/config.json');
    if (response.ok) {
      const config = await response.json();
      cachedConfig = {
        apiUrl: config.apiUrl,
        cognitoUserPoolId: config.cognitoUserPoolId,
        cognitoClientId: config.cognitoClientId,
      };
      return cachedConfig;
    }
  } catch {
    // Config file not available, fall back to env vars
  }

  // Fall back to VITE_* env vars (for local development)
  cachedConfig = {
    apiUrl: import.meta.env.VITE_API_URL || '',
    cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  };

  return cachedConfig;
}

export function getConfig(): AppConfig | null {
  return cachedConfig;
}
